import MutateLessonPlan from "./MutateLessonPlan";

export default MutateLessonPlan